import { render, staticRenderFns } from "./OnboardingPaymentSuccessful.vue?vue&type=template&id=6006d7d8&"
import script from "./OnboardingPaymentSuccessful.vue?vue&type=script&lang=js&"
export * from "./OnboardingPaymentSuccessful.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingPaymentSuccessful.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports